import { Api } from 'helpers/ApiClient';
import { buildFormData } from 'helpers/Form';

export class Account {
  static async linksList(id) {
    try {
      const response = await Api.client.get(
        `/api/v1/accounts/${id}/links.json`,
      );
      return response.data;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error linksList',
      };
    }
  }

  static async updateLink(accId, param) {
    try {
      const response = await Api.client.put(
        `/api/v1/accounts/${accId}/links/${param.id}`,
        buildFormData(param.body, 'link'),
      );
      return response.data;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateLink',
      };
    }
  }

  static async addLink(id, param) {
    try {
      const response = await Api.client.post(
        `/api/v1/accounts/${id}/links`,
        buildFormData(param, 'link'),
      );
      return response.data;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateLink',
      };
    }
  }

  static async moveLink(id, param) {
    try {
      const response = await Api.client.post(
        `/api/v1/accounts/${id}/links/${param.id}/move`,
        param.body,
      );
      return response;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error moveLinkLink',
      };
    }
  }

  static async removeLink(accId, id) {
    try {
      const response = await Api.client.delete(
        `/api/v1/accounts/${accId}/links/${id}`,
      );
      return response.data;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error removeLink',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/links/api.js